import { createFilterOptions } from "@mui/material";
import { NestedOption, NestedSubOption } from "./types";

export const filter = createFilterOptions<NestedSubOption>();

// flatten NestedOption to NestedSubOption adding parent to each children
export function flatten(options: NestedOption[]) {
    const flattened: NestedSubOption[] = [];
    options.forEach(option => {
        option?.children.forEach(child => {
            flattened.push({
                ...child,
                parent: {
                    name: option?.name,
                    id: option?.id,
                },
            });
        });
    });
    return flattened.sort((a, b) => {
        const _a = a.parent?.order + a.order;
        const _b = b.parent?.order + b.order;

        return _a - _b;
    });
}
